
const plexusCanvas = document.getElementById("plexusCanvas");
const ctxPlexus = plexusCanvas.getContext("2d");

// Configuration du plexusCanvas
plexusCanvas.width = window.innerWidth;
plexusCanvas.height = window.innerHeight;

// Variables pour les particules
let particles = [];
const particleCount = 100;
const maxDistance = 90; // Distance maximale pour connecter les particules
const mouse = { x: null, y: null }; // Position de la souris

// Fonction pour générer des particules
class Particle {
    constructor() {
        this.x = Math.random() * plexusCanvas.width;
        this.y = Math.random() * plexusCanvas.height;
        this.vx = Math.random() * 1 - 1; // Vitesse horizontale
        this.vy = Math.random() * 1 - 1; // Vitesse verticale
        this.radius = Math.random() * 5; // Taille des particules
    }

    update(){
        const dx = mouse.x - this.x;
        const dy = mouse.y - this.y;

        const distance = Math.sqrt(dx * dx + dy * dy);

        const force = 0.002;
        const nx = dx/distance;
        const ny = dy/distance;
        this.vx += nx * force;
        this.vy += ny * force;

        // if (distance < 10) {
        //     this.vx *= 0.95;
        //     this.vy *= 0.95;
        // }

        this.x += this.vx;
        this.y += this.vy;
    }

    draw() {
        ctxPlexus.beginPath();
        ctxPlexus.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctxPlexus.fillStyle = "#0694A2";
        ctxPlexus.fill();

        // ctxPlexus.arc(this.x, this.y, this.radius + 2, 0, Math.PI * 2);
        // ctxPlexus.strokeStyle = "white";
        // ctxPlexus.stroke();
    }

    move() {
        this.x += this.vx;
        this.y += this.vy;

        // Rebondir sur les bords
        if (this.x <= 0 || this.x >= plexusCanvas.width){
            this.vx *= -1;
            this.radius = Math.random() * 5;
        }
        if (this.y <= 0 || this.y >= plexusCanvas.height){
            this.vy *= -1;
            this.radius = Math.random() * 5;
        }
    }
}

// Initialisation des particules
function initParticles() {
    for (let i = 0; i < particleCount; i++) {
        particles.push(new Particle());
    }
}

// Dessiner les connexions entre les particules
function connectParticles() {
    for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
            const dx = particles[i].x - particles[j].x;
            const dy = particles[i].y - particles[j].y;
            const distance = Math.sqrt(dx * dx + dy * dy);

            if (distance < maxDistance) {
                ctxPlexus.beginPath();
                ctxPlexus.moveTo(particles[i].x, particles[i].y);
                ctxPlexus.lineTo(particles[j].x, particles[j].y);
                ctxPlexus.strokeStyle = `rgba(255, 255, 255, ${1 - distance / maxDistance})`;
                ctxPlexus.stroke();
            }
        }
    }
}

// Dessiner les particules et leurs interactions
function animer() {
    ctxPlexus.clearRect(0, 0, plexusCanvas.width, plexusCanvas.height);

    particles.forEach((particle) => {
        particle.move();
        particle.draw();
    });

    connectParticles();
    drawMouseInteraction(); // Ajouter les interactions avec la souris

    requestAnimationFrame(animer);
}

// Ajouter les interactions avec la souris
function drawMouseInteraction() {
    if (mouse.x && mouse.y) {
        particles.forEach((particle) => {
            const dx = mouse.x - particle.x;
            const dy = mouse.y - particle.y;
            const distance = Math.sqrt(dx * dx + dy * dy);

            if (distance < maxDistance) {
                ctxPlexus.beginPath();
                ctxPlexus.moveTo(mouse.x, mouse.y);
                ctxPlexus.lineTo(particle.x, particle.y);
                ctxPlexus.strokeStyle = `rgba(255, 255, 255, ${1 - distance / maxDistance})`;
                ctxPlexus.stroke();
            }
            // particle.update();
        });
    }
}

// Suivre la position de la souris
window.addEventListener("mousemove", (e) => {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
});

// Adapter le plexusCanvas au redimensionnement
window.addEventListener("resize", () => {
    plexusCanvas.width = window.innerWidth;
    plexusCanvas.height = window.innerHeight;
});

initParticles();
animer();
